export const fieldIndexTuples: [string, number][] = [
  ['name', 1],
  ['username', 1],
  ['availability', 2],
  ['contacts', 3],
  // field and form index to be navigated
  // Add more fields and their corresponding form indices as needed
];
